import React, { useState, CSSProperties } from 'react'
import { colors } from '../../sharedComponents/colors'
import { IconButton } from '../Atoms/Buttons'
import { IconClose, IconSearch } from '../../Assets/Icons/TinyIcons'
import styled from 'styled-components'
import { useTranslation } from 'react-i18next'

const styles: { [key: string]: CSSProperties } = {
  rowContainer: {
    display: 'flex',
    flexDirection: 'row',
    marginBottom: '10px'
  },
  searchContainer: {
    borderStyle: 'solid',
    borderRadius: '4px',
    borderColor: 'gray',
    borderWidth: '1px',
    display: 'flex',
    flexDirection: 'row',
    flex: '1',
    fontSize: '14px',
    marginLeft: '30px',
    marginRight: '10px',
    paddingLeft: '5px',
    paddingRight: '1px'
  },
  searchBar: {
    color: colors.brand.black,
    borderWidth: '0px',
    flex: 1,
    height: '35px',
    marginLeft: '10px',
    paddingLeft: '10px',
    backgroundColor: colors.system.white,
    outline: "none",
  },
  spacer: {
    flex: 2
  }
}

const ResetContainer = styled.div`
  display: flex;
  align-items: center;
  margin-left: 12px;
  align-self: center;
  margin: 1% 0 0 0;
`

const ResetButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 6px 8px;
  min-width: 72px;
  height: 35px;
  border: 1px solid rgb(188, 187, 187);
  border-radius: 6px;
  background: #fff;
  color: #0b3b91;
  font-size: 13px;
  cursor: pointer;
  &:hover {
    background: #eef4ff;
  }
`

interface SearchRowProps {
  setSearchQuery: (query: string) => void
  placeholderText: string
  backgroundColor?: string
}

export const SearchRowWithResetButton: React.FC<SearchRowProps> = ({
  setSearchQuery,
  placeholderText,
  backgroundColor = colors.system.white
}) => {
  const [query, setQuery] = useState('')

  const { t } = useTranslation(['common', 'actions'])


  const clearAllInput = () => {
    setSearchQuery('')
    setQuery('')
  }
  return (
    <div style={styles.rowContainer}>
      <div style={{ ...styles.searchContainer, backgroundColor }}>
        <IconButton
          buttonProps={{
            onClick: e => {
              e.preventDefault()
              e.stopPropagation()
              setSearchQuery(query)
            }
          }}
          icon={<IconSearch color={colors.system.grey_1} />}
        />
        <input
          style={styles.searchBar}
          value={query}
          onChange={e => setQuery(e.target.value)}
          onKeyPress={e => {
            if (e.key === 'Enter') {
              setSearchQuery(query)
            }
          }}
          placeholder={placeholderText}
        />
      </div>
      <div style={styles.buttonContainer}>
        <ResetContainer>
          <ResetButton
            type="button"
            data-cy="reset-filters"
            onClick={(e: React.MouseEvent<HTMLButtonElement>) => {
              clearAllInput()
            }}
            title={t('common:actions.reset', 'Reset')}
          >
            {t('common:actions.reset', 'Reset')}
          </ResetButton>
        </ResetContainer>
      </div>
      <div style={styles.spacer}/>
    </div>
  )
}
export default SearchRowWithResetButton
